import { f as r } from "./fails.js";
var t = function t(_t) {
  return r(function () {
    var r = ""[_t]('"');
    return r !== r.toLowerCase() || r.split('"').length > 3;
  });
};
export { t as s };